// extracted by mini-css-extract-plugin
module.exports = {"navItem":"index-module__navItem___3PdQx typography-module__bodyFont___1AHtE","active":"index-module__active___33k5q"};